const NEGATIVE_MEANING = -1;
const MATH_ROUND = 20;

export { NEGATIVE_MEANING, MATH_ROUND };